import { createRef, useRef, useState } from "react";
import { FormInstance, notification } from "antd";
import { AddressRef, UspsAddresses } from "../types/LocationTypes";
import { formatAddress } from "../helpers/personHelpers";

export function useUspsValidator(
  form: FormInstance,
  handleSubmitForm: Function
) {
  const [isUspsAddressModalVisible, setIsUspsAddressModalVisible] = useState<
    boolean
  >(false);
  const addressRef = useRef([createRef<AddressRef>(), createRef<AddressRef>()]);
  const uspsAddresses = useRef<UspsAddresses>({
    homeAddress: null,
    mailingAddress: null,
  });

  async function handleUspsValidationAndSubmitForm() {
    try {
      const [homeAddressState, mailingAddressState] = addressRef?.current?.map(
        (ref) => ({
          isManualEntry: !!ref.current?.isEnterManualAddress,
          validateUsps: ref.current?.validateManualAddress,
        })
      );

      if (homeAddressState.isManualEntry || mailingAddressState.isManualEntry) {
        let isValidHomeAndMailingAddress;
        const isSameAsHomeAddress = form.getFieldValue("isSameAsHomeAddress");

        if (isSameAsHomeAddress && homeAddressState.validateUsps) {
          const result = await homeAddressState.validateUsps();
          const formattedUspsAddress = formatAddress(result.uspsAddress);
          uspsAddresses.current = {
            homeAddress: formattedUspsAddress,
            mailingAddress: formattedUspsAddress,
          };
          isValidHomeAndMailingAddress = result.isValid;
        }

        if (
          !isSameAsHomeAddress &&
          homeAddressState.validateUsps &&
          mailingAddressState.validateUsps
        ) {
          const validationResults = await Promise.all([
            homeAddressState.validateUsps(),
            mailingAddressState.validateUsps(),
          ]);
          uspsAddresses.current = {
            homeAddress: formatAddress(validationResults[0].uspsAddress),
            mailingAddress: formatAddress(validationResults[1].uspsAddress),
          };
          isValidHomeAndMailingAddress = validationResults.every(
            (result) => result.isValid
          );
        }

        if (isValidHomeAndMailingAddress) {
          setIsUspsAddressModalVisible(true);
        }
      } else {
        handleSubmitForm();
      }
    } catch (error) {
      notification.error({
        message: "Failed USPS Validation",
      });
    }
  }

  return {
    addressRef,
    uspsAddresses,
    handleUspsValidationAndSubmitForm,
    isUspsAddressModalVisible,
    setIsUspsAddressModalVisible,
  };
}
